import React from 'react';
import { Checkbox, Dimmer, Header, Segment, Table } from 'semantic-ui-react';

class LegacyTabPermissions extends React.Component {
  state = {enabled: false};

  render() {
    const { label, subtabs } = this.props;
    const { enabled } = this.state;
    return (
      <Segment>
        <Header as="h4">{label}</Header>
        <Checkbox toggle checked={enabled} onChange={this.handleChangeEnabled} />

        {subtabs && (
          <Dimmer.Dimmable blurring as={Segment} dimmed={!enabled}>
            <Header as="h5">Subtabs</Header>
            <Table collapsing>
              <Table.Body>
                {subtabs.map((subtab) => (
                  <Table.Row key={subtab.label}>
                    <Table.Cell>
                      <Checkbox label={subtab.label} />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            <Dimmer inverted active={!enabled} />
          </Dimmer.Dimmable>
        )}
      </Segment>
    );
  }

  handleChangeEnabled = (e) => {
    e.preventDefault();
    this.setState((state) => ({...state, enabled: !state.enabled}));
  };
}

export default LegacyTabPermissions;
